const serviceDetails = {
  "audit": {
    "title": "Audit Services",
    "slug": "audit",
    "description": "Comprehensive review to ensure that the accounts are prepared in accordance with Generally Accepted Accounting Policies and applicable Accounting Standards/IFRS. Checking the genuineness of the expenses booked in accounts.",
    "icon": "FiSearch",
    "blocks": [
      {
        "type": "heading",
        "level": "h4",
        "text": "Broadly, Audit involves the following :"
      },
      {
        "type": "list",
        "style": "bullet",
        "items": [
          "Indepth study of existing systems, procedures and controls for proper understanding. Suggestions for improvement and strengthening.",
          "Ensuring compliance with policies, procedures and statutes.",
          "Comprehensive review to ensure that the accounts are prepared in accordance with Generally Accepted Accounting Policies and applicable Accounting Standards/IFRS.",
          "Checking the genuineness of the expenses booked in accounts.",
          "Reporting inefficiencies at any operational level.",
          "Detection and prevention of leakages of income and suggesting corrective measures to prevent recurrence.",
          "Certification of the books of account being in agreement with the Balance Sheet and Profit and Loss Account.",
          "Issue of Audit Reports under various laws."
        ]
      },
      {
        "type": "heading",
        "level": "h4",
        "text": "Types of Audits conducted :"
      },
      {
        "type": "list",
        "style": "bullet",
        "items": [
          "Statutory Audit of Companies",
          "Tax Audit under Section 44AB of the Income Tax Act, 1961.",
          "Audit under other sections of the Income Tax Act, 1961 such as 80HHC, 80-IA, etc.",
          "Concurrent Audits.",
          "Revenue Audit of Banks.",
          "Branch Audits of Banks.",
          "Audit of PF Trusts, Charitable Trusts, Schools, etc.",
          "Audit of Co-operative Societies.",
          "Information System Audit",
          "Internal Audits."
        ]
      }
    ]
  },
  "corporate_services": {
    "title": "Corporate Services",
    "slug": "corporate-services",
    "description": "Planning for Mergers, Acquisitions, De-mergers, and Corporate re-organizations. Filing of annual returns and various forms, documents. Consultancy on Company Law matters.",
    "icon": "FiBriefcase",
    "blocks": [
      {
        "type": "heading",
        "level": "h4",
        "text": "Broadly, Corporate Services involve the following :"
      },
      {
        "type": "list",
        "style": "bullet",
        "items": [
          "Incorporation of company",
          "Consultancy on Company Law matters.",
          "Planning for Mergers, Acquisitions, De-mergers, and Corporate re-organizations.",
          "Filing of annual returns and various forms, documents.",
          "Clause 49 review for compliance with fiscal, corporate and tax laws",
          "Secretarial Matters including share transfers",
          "Maintenance of Statutory records",
          "Consultancy on Public/Rights/Bonus Issue of shares.",
          "Change of Name, Objects, Registered Office, etc."
        ]
      }
    ]
  },
  "corporate_finance": {
    "title": "Corporate Finance",
    "slug": "corporate-finance",
    "description": "Preparations of Project Reports, CMA data for bank loans, private placements, working capital limits, and External Credit Borrowings.",
    "icon": "FiTrendingUp",
    "blocks": [
      {
        "type": "heading",
        "level": "h4",
        "text": "Broadly, Corporate Finance involves the following :"
      },
      {
        "type": "list",
        "style": "bullet",
        "items": [
          "Preparations of Project Reports",
          "Preparation of CMA data for bank loans",
          "Private placement of shares, Inter-Corporate Deposit, Terms loans, working capital limits, etc",
          "External Credit Borrowings (ECBs)"
        ]
      }
    ]
  },
  "non_residents": {
    "title": "Services for Non-Residents",
    "slug": "non-residents",
    "description": "FEMA compliance, PAN allotment, tax planning, advance tax rulings, repatriation certificates, and RBI applications for purchase/sale of property.",
    "icon": "FiGlobe",
    "blocks": [
      {
        "type": "heading",
        "level": "h4",
        "text": "Broadly, Services for Non-Residents involve the following :"
      },
      {
        "type": "list",
        "style": "bullet",
        "items": [
          "Allotment of Permanent Account number (PAN)",
          "Tax planning.",
          "Obtaining Advance Rulings on debatable issues.",
          "Consultancy/ advice on FEMA/RBI matters.",
          "Filing Income Tax/ Wealth Tax Returns",
          "Advice on making investments",
          "Issuing certificate for repatriation of income / assets from India.",
          "Making application to RBI for various matters including sale and purchase of residential and commercial properties."
        ]
      }
    ]
  },
  "accounting": {
    "title": "Accounting Services",
    "slug": "accounting",
    "description": "Accounting System Design & Implementation, Financial Accounting, Budgeting, MIS reporting, and Depreciation schedules.",
    "icon": "FiBookOpen",
    "blocks": [
      {
        "type": "heading",
        "level": "h4",
        "text": "Broadly, Accounting Services involve the following :"
      },
      {
        "type": "list",
        "style": "bullet",
        "items": [
          "Accounting System Design & Implementation",
          "Financial Accounting",
          "Budgeting",
          "Financial Reporting",
          "MIS Reports",
          "Financial Analysis",
          "Asset Accounting Management",
          "Depreciation and Amortization Schedules"
        ]
      }
    ]
  },
  "payroll": {
    "title": "Payroll Services",
    "slug": "payroll",
    "description": "Monthly salary sheets, statutory deductions (PF, ESI, PT), online disbursements, secure payslips, Form 16, and gratuity administration.",
    "icon": "FiUsers",
    "blocks": [
      {
        "type": "heading",
        "level": "h4",
        "text": "Broadly, Payroll Services involve the following :"
      },
      {
        "type": "list",
        "style": "bullet",
        "items": [
          "Preparation of Monthly Salary Sheet.",
          "Deductions as per applicable laws like Income Tax, Provident Fund, and Professional Tax etc.",
          "Computation and deposit of TDS, ESI, PF etc.",
          "Disbursement/ Online Payment of Salary.",
          "Pay slip by password protected e-mail.",
          "Reimbursement of telephone, medical bills etc.",
          "Issue of Form 16 to employees.",
          "Periodic Reconciliation of payments/statutory deductions etc. with books of accounts.",
          "Administration of gratuity, superannuation, pension schemes etc."
        ]
      }
    ]
  },
  "outsourcing": {
    "title": "Benefits of Outsourcing",
    "slug": "outsourcing",
    "description": "Concentrate on core business activities, reduce investment in fixed assets, achieve substantial cost savings, and access expert services with off-site data backup.",
    "icon": "FiArrowRight",
    "blocks": [
      {
        "type": "heading",
        "level": "h4",
        "text": "Outsourcing offers key strategic advantages :"
      },
      {
        "type": "list",
        "style": "bullet",
        "items": [
          "Enables business to concentrate on core business activities.",
          "Use of manpower for more important functions",
          "Investment in fixed assets reduced/minimized.",
          "Substantial Savings in Cost.",
          "Services of experts made available.",
          "Improved Internal Controls",
          "Enhanced reporting capabilities to provide more timely and accurate financial data",
          "Off-site Backup of Data."
        ]
      }
    ]
  },
  "income_tax": {
    "title": "Income Tax",
    "slug": "income-tax",
    "description": "Effective tax management, corporate planning, search/seizure litigation, ITR filing for individuals/firms, DTAA opinions, and refund coordination.",
    "icon": "FiShield",
    "blocks": [
      {
        "type": "heading",
        "level": "h4",
        "text": "Broadly, Income Tax services involve the following :"
      },
      {
        "type": "list",
        "style": "bullet",
        "items": [
          "Consultancy on various intricate matters pertaining to Income tax.",
          "Effective Tax Management and Advisory Services.",
          "Tax Planning for Corporates and others.",
          "Designing / restructuring salary structure to minimise tax burden.",
          "Obtaining Advance tax Rulings.",
          "Obtaining No Objection Certificates from Income Tax department.",
          "Obtaining PAN for assessees, employees etc.",
          "Advance tax estimation and deposit.",
          "Assessing the liability towards deferred taxes.",
          "Providing regular updates on amendments, circulars, notifications & judgments.",
          "Filing Income Tax and Wealth Tax returns for all kinds of assessees.",
          "Filing Income tax returns for employees of corporate clients.",
          "Liaison with Income tax department for rectification, assessment, obtaining refunds etc.",
          "Expertise in complicated direct tax assessments.",
          "Filing and pleading appeals under various provisions of IT Act.",
          "Special expertise in search, seizure and prosecution litigation.",
          "Advice on future tax implications in respect of the potential acquisition.",
          "Opinions on the various Double Tax Avoidance Agreement related issues.",
          "Settlement of various issues raised under FEMA."
        ]
      }
    ]
  },
  "gst": {
    "title": "GST",
    "slug": "gst",
    "description": "GST registrations, return filings (Regular, Composition, ISD), audits, assessments, ITC data compilation, and transition management.",
    "icon": "FiFileText",
    "blocks": [
      {
        "type": "heading",
        "level": "h4",
        "text": "Broadly, GST services involve the following :"
      },
      {
        "type": "list",
        "style": "bullet",
        "items": [
          "GST Migrations and Registrations",
          "Filing of GST Returns (Regular Dealer, Composition Dealer, ISD, Non-Resident, E-Commerce, etc)",
          "GST Consultancy/Advisory on various issues of GST",
          "Impact Analysis on Business Segments",
          "GST Audits as per GST Act, 2017",
          "GST Implementation",
          "Compilation of Data of Input Tax Credit",
          "GST Assessments",
          "Transition from Pre-GST to GST Regime",
          "Maintenance of Records for Compliance",
          "Strategic Business Planning under GST Regime",
          "Supplier/Buyer Management",
          "GSTN Number Verification Services",
          "HSN Code Finder"
        ]
      }
    ]
  },
  "tds": {
    "title": "Tax Deducted at Source (TDS)",
    "slug": "tds",
    "description": "TAN registration, monthly computation & deposit, quarterly E-TDS return filing, correction statement submission, and assessment support.",
    "icon": "FiSettings",
    "blocks": [
      {
        "type": "heading",
        "level": "h4",
        "text": "Broadly, TDS services involve the following :"
      },
      {
        "type": "list",
        "style": "bullet",
        "items": [
          "Advice on all matters related to compliance of TDS/TCS provisions.",
          "Obtaining Tax Deduction Account Number (TAN).",
          "Periodic review of TDS/ Withholding Tax compliance.",
          "Computation of monthly TDS.",
          "Monthly reconciliation of TDS due and deposited.",
          "Monthly deposit of TDS electronically/manually.",
          "Issue of monthly/annual TDS certificates.",
          "Filing of quarterly E-TDS/Manual Returns.",
          "Filing of Correction Statements.",
          "TDS assessment."
        ]
      }
    ]
  },
  "corporate_governance": {
    "title": "Corporate Governance",
    "slug": "corporate-governance",
    "description": "Independent verification, supervision audit committee formation, disclosure reviews, and active participation in board proceedings.",
    "icon": "FiShield",
    "blocks": [
      {
        "type": "heading",
        "level": "h4",
        "text": "Broadly, Corporate Governance involves the following :"
      },
      {
        "type": "list",
        "style": "bullet",
        "items": [
          "Periodic monitoring through internal audit",
          "Independent audit",
          "Independent verification",
          "Effective Supervision",
          "Accountability",
          "Sufficient number of Independent directors on the Board.",
          "Formation of an independent audit committee for the board",
          "Adequate disclosure and transparency in reports",
          "Participation in board meetings."
        ]
      }
    ]
  }
};

export default serviceDetails;
